var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHumidity = function SvgHumidity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f254d2be-2b65-49ff-b87d-853a4d67f619",
    "data-name": "Layer 4",
    viewBox: "0 0 70.7 105",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ab5e6b30-4c59-4ef0-a0b6-8f8fba4ad806",
    d: "M81.2,112.67a35.3,35.3,0,0,1-25-10.34h0A35.46,35.46,0,0,1,50.48,59.8L79.69,8.55a1.73,1.73,0,0,1,1.51-.88,1.71,1.71,0,0,1,1.51.88L111.93,59.8A35.35,35.35,0,0,1,81.2,112.67ZM58.65,99.87a31.89,31.89,0,0,0,50.26-38.35L81.2,12.92,53.5,61.52a32,32,0,0,0,5.15,38.35l-1.23,1.23Z",
    transform: "translate(-45.85 -7.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ab5e6b30-4c59-4ef0-a0b6-8f8fba4ad806",
    d: "M81.2,101.28a1.74,1.74,0,0,1,0-3.48,21.64,21.64,0,0,0,19.51-12.39,1.74,1.74,0,1,1,3.15,1.48A25.14,25.14,0,0,1,81.2,101.28Z",
    transform: "translate(-45.85 -7.67)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHumidity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/humidity.45f85c52.svg";
export { ForwardRef as ReactComponent };